<template>
    <form
        class="appForm"
        @submit.prevent="$emit('submit')"
    >
        <div class="top flex justify-between items-center">
            <div class="left">
                <h1>{{ heading }}</h1>
            </div>
            <div class="right">
                <AppButton
                    :label="isNew ? 'Create' : 'Update'"
                    :loading="loading"
                    class="w-full"
                    button-type="submit"
                />
            </div>
        </div>
        <div class="body flex justify-between items-start flex-wrap">
            <Box
                :class="{ 'fullWidth': !hasSideSlot }"
                class="main"
            >
                <template v-slot:top>
                    <slot name="tabs" />
                </template>
                <div class="inner">
                    <slot name="main" />
                </div>
            </Box>
            <Box
                v-if="hasSideSlot"
                class="side"
            >
                <slot name="side"/>
            </Box>
        </div>
    </form>
</template>

<script>
import Box from '../ui/Box.vue';
import AppButton from '../ui/AppButton.vue';

export default {
    components: {
        Box,
        AppButton,
    },
    props: {
        heading: {
            type: String,
            required: true,
        },
        isNew: {
            type: Boolean,
            default: true,
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        hasSideSlot() {
            return !!this.$slots.side;
        },
    },
};
</script>

<style lang="postcss" scoped>
.top {
    margin-bottom: 25px;
}
.main {
    padding: 0;
    margin-right: 50px;
    width: calc(100% - 400px);
    @media (--laptop) {
        margin-right: 30px;
        width: calc(100% - 290px);
    }
    &.fullWidth {
        width: 100%;
        margin-right: 0;
    }
}
.side {
    width: 350px;
    @media (--laptop) {
        width: 260px;
    }
}
</style>
